import { Block, Inline } from '@contentful/rich-text-types';
import { Next, NodeRenderer } from '@contentful/rich-text-html-renderer';

export const getInlineEntryHyperlinkHtml = ((
  _node: Block | Inline,
  _next: Next,
) => {
  return 'The inline entry hyperlink is not supported yet in this feature.';
}) as NodeRenderer;
